// import {EditorState, Modifier, SelectionState} from 'draft-js';
import EquationBlock from './EquationBlock';

function testBlock(block, contentState) {
  if (block.getType() === 'atomic') {
    const key = block.getEntityAt(0);
    return key && contentState.getEntity(key).getType() === 'EQUATION';
  }
  return false;
}

export default function blockRenderer(block, contentState, blockProps) {
  return (
    testBlock(block, contentState) && {
      component: EquationBlock,
      editable: false,
      props: blockProps,
    }
  );
}

// export function removeTeXBlock(editorState, blockKey) {
//   var content = editorState.getCurrentContent();
//   var block = content.getBlockForKey(blockKey);

//   var targetRange = new SelectionState({
//     anchorKey: blockKey,
//     anchorOffset: 0,
//     focusKey: blockKey,
//     focusOffset: block.getLength(),
//   });

//   var withoutTeX = Modifier.removeRange(content, targetRange, 'backward');
//   var resetBlock = Modifier.setBlockType(
//     withoutTeX,
//     withoutTeX.getSelectionAfter(),
//     'unstyled'
//   );

//   var newState = EditorState.push(editorState, resetBlock, 'remove-range');
//   return EditorState.forceSelection(newState, resetBlock.getSelectionAfter());
// }
